<template>
    <el-container>
        <el-header>
            <el-form @submit.native.prevent :inline="true" :model="fromAlarmLevel" ref="fromAlarmLevel" class="demo-form-inline">
                <td-permission :permissions="permissionsQuery">
                    <div slot="havePermission">
                        <el-form-item :label="$t('common.NAME')" prop="sName">
                            <td-input v-model="fromAlarmLevel.sName"></td-input>
                        </el-form-item>
                    </div>
                </td-permission>
                <el-form-item class="paddingLeft10">
                    <td-button type="primary" :permissions="permissionsQuery" @getPermissionsStatus="getPermissionsStatus" :loading="loading" @click="btnClickQuery">{{
                        $t('common.QUERY')
                    }}</td-button>
                    <td-button type="button" :permissions="permissionsAdd" @click="btnAddLevel">{{ $t('common.ADD') }}</td-button>
                    <td-button type="button" :permissions="permissionsDelete" @click="btnDeleteLevel">{{ $t('common.DELETE_BATCH') }}</td-button>
                </el-form-item>
            </el-form>
        </el-header>
        <el-main>
            <!-- 加载表格 -->
            <td-table
                :columns="columns"
                ref="tableInfo"
                :dataSource="tableData"
                :pageSize="pageSize"
                :currentPage="currentPage"
                :total="total"
                @handleSizeChange="handleSizeChange"
                @currentChange="currentChange"
                :permissions="permissionsQuery"
                :rowKey="rowKey"
            ></td-table>
            <!-- 加载dialog -->
            <dialog-levelInfo
                v-if="dialogLevelVisible"
                :isAddData="isAddData"
                :dialogLevelVisible="dialogLevelVisible"
                :editItem="editItem"
                :title="title"
                @levelDialogClose="levelDialogClose"
                @submit="submit"
            ></dialog-levelInfo>
        </el-main>
    </el-container>
</template>

<script>
import api from './assets/api.js';
import dialogLevelInfo from './components/dialogLevelInfo.vue';
export default {
    // 初始化渲染
    components: {
        'dialog-levelInfo': dialogLevelInfo
    },
    // 定义数据
    data() {
        return {
            fromAlarmLevel: { sName: '' },
            permissionsQuery: ['alarmLevel:view'],
            permissionsAdd: ['alarmLevel:add'],
            permissionsDelete: ['alarmLevel:del'],
            editItem: '',
            dialogLevelVisible: false,
            tableData: [],
            isAddData: true, // 是否为添加数据
            pageSize: 10, // 每页条数
            currentPage: 1, // 当前页
            total: 0, // 总条数
            loading: false, // 按钮是否为加载状态
            rowKey: 'sId',
            columns: [
                {
                    prop: 'iLevel',
                    label: this.$t('common.LEVEL'),
                    align: 'center',
                    tableWidth: '100'
                },
                {
                    prop: 'sName',
                    label: this.$t('common.NAME'),
                    align: 'center'
                },
                {
                    prop: 'sDescribe',
                    label: this.$t('common.DESCRIPTION')
                },
                {
                    prop: '',
                    label: this.$t('common.OPERATE'),
                    align: 'center',
                    render: (createElement, params) => {
                        return createElement('div', [
                            createElement(
                                'td-button',
                                {
                                    props: { type: 'text', size: 'small', permissions: ['alarmLevel:edit'] },
                                    on: {
                                        click: () => {
                                            this.btnExit(params.row);
                                        }
                                    }
                                },
                                this.$t('common.EDIT')
                            ),
                            createElement(
                                'td-button',
                                {
                                    props: { type: 'text', size: 'small', permissions: ['alarmLevel:del'] },
                                    on: {
                                        click: () => {
                                            this.btnDelete([params.row.sId]);
                                        }
                                    }
                                },
                                this.$t('common.DELETE')
                            )
                        ]);
                    }
                }
            ]
        };
    },
    // 方法的实现
    methods: {
        // 获取每页条数
        handleSizeChange(pageSize) {
            this.pageSize = pageSize;
            this.submit();
        },
        getPermissionsStatus(permissions) {
            if (permissions) {
                this.btnQuery(); // 进行页面初始化数据的加载
            }
        },
        // 获取当前页
        currentChange(currentPage) {
            this.currentPage = currentPage;
            this.submit();
        },
        //查询点击按钮
        btnClickQuery() {
            this.currentPage = 1;
            this.btnQuery();
        },
        // 查询数据
        btnQuery() {
            this.loading = true;
            let param = {
                sname: this.fromAlarmLevel.sName,
                pageNum: this.currentPage,
                pageSize: this.pageSize,
                isPage: true
            };
            api.getAlarmLevel(JSON.stringify(param), response => {
                if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    this.$log.error('alarm/getAlarmLevel', response.data.statusMessage);
                    this.loading = false;
                    return;
                }
                this.tableData = response.data.content;
                this.total = response.data.count;
                this.loading = false;
            });
        },
        // 添加
        btnAddLevel() {
            this.title = this.$t('common.ADD'); // 标题
            this.isAddData = true;
            this.dialogLevelVisible = true;
        },
        // 编辑
        btnExit(row) {
            this.editItem = row;
            this.title = this.$t('common.EDIT');
            this.isAddData = false;
            this.dialogLevelVisible = true;
        },
        // 获取选中表格数据的id
        getTableSelectId() {
            let selectData = this.$refs.tableInfo.getSelectAllRows();
            let tableId = [];
            for (let i = 0; i < selectData.length; i++) {
                tableId.push(selectData[i].sId);
            }
            return tableId;
        },
        // 批量删除
        btnDeleteLevel() {
            let tableId = this.getTableSelectId();
            if (tableId.length === 0) {
                this.$message({ showClose: true, message: this.$t('common.PLEASE_SELECT'), type: 'warning' });
                return;
            }
            this.btnDelete(tableId);
        },
        // 删除接口
        btnDelete(sId) {
            this.$confirm(this.$t('common.DELETE_INFO_TIPS'), this.$t('common.TIPS'), {
                confirmButtonText: this.$t('common.SURE'),
                cancelButtonText: this.$t('common.CANCEL'),
                type: 'warning'
            })
                .then(() => {
                    api.deleteAlarmLevel(JSON.stringify(sId), response => {
                        if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                            this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                            this.$log.error('alarm/deleteAlarmLevel', response.data.statusMessage);
                            return;
                        }
                        this.$message({ showClose: true, message: this.$t('common.DELETE_SUCCESS'), type: 'success' });
                        this.submit();
                    });
                })
                .catch(() => {});
        },
        // 组件关闭需要调用的方法
        submit() {
            this.btnQuery();
        },
        // 关闭页面
        levelDialogClose() {
            this.dialogLevelVisible = false;
        }
    }
};
</script>
